import React from "react";
import Home from "./Home";
import Service from "./Service";
import About from "./About";
import Contact from "./Contact";
import "./index.css";
import "./modern-theme.css";

function App() {
  return (
    <>
      <a href="#main-content" className="skip-to-main">Skip to main content</a>
      <main id="main-content">
        <Home />
        <Service />
        <About />
        <Contact />
      </main>
      <footer className="site-footer">
        <p>&copy; {new Date().getFullYear()} ILGI Tech Solutions SRL. All rights reserved.</p>
      </footer>
    </>
  );
}

export default App;
